import React from 'react';
import PropTypes from 'prop-types';
import logo from 'assets/images/logo-horizontal-white.png';

export function SolidLogo({ className }) {
  return <img src={logo} alt="sample" className={className} />;
}

SolidLogo.defaultProps = {
  className: '',
};

SolidLogo.propTypes = {
  className: PropTypes.string,
};

export function ColoredLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="163.536"
      height="43.687"
      viewBox="0 0 163.536 43.687"
    >
      <defs>
        <linearGradient
          id="a"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#ed7015" />
          <stop offset="1" stopColor="#eda215" />
        </linearGradient>
        <linearGradient
          id="b"
          x1="0.799"
          x2="0"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#295fa6" />
          <stop offset="1" stopColor="#2197c6" />
        </linearGradient>
      </defs>
      <path
        fill="url(#a)"
        stroke="rgba(0,0,0,0)"
        strokeMiterlimit="10"
        d="M33.791 0a16.652 16.652 0 01-2.357 2.959A16.5 16.5 0 0119.743 7.8 16.5 16.5 0 018.051 2.959 16.583 16.583 0 015.7 0H0a21.3 21.3 0 001.34 2.54 21.655 21.655 0 003.147 3.982 21.53 21.53 0 0015.256 6.325A21.53 21.53 0 0035 6.522a21.658 21.658 0 003.145-3.982A21.313 21.313 0 0039.485 0z"
        transform="translate(-1010.132 -157.022) translate(1010.132 157.022) translate(1.852 30.34)"
      />
      <path
        fill="url(#b)"
        d="M37.729 25.3A16.55 16.55 0 0033.3 9.9l-8.141 8.14-3.564 3.564-3.565-3.562L9.889 9.9a16.55 16.55 0 00-4.43 15.4H.318a21.644 21.644 0 019.988-22.11l3.7 3.7 7.591 7.591 7.59-7.591 3.7-3.7a21.831 21.831 0 013.981 3.149A21.59 21.59 0 0142.87 25.3zM21.594 5.042a16.64 16.64 0 00-2.684.217l-4.149-4.15a21.61 21.61 0 0113.667 0l-4.151 4.15a16.635 16.635 0 00-2.683-.217z"
        transform="translate(-1010.132 -157.022) translate(1010.132 157.022)"
      />
      <g>
        <path
          fill="url(#b)"
          d="M99.351 25.971v-3.617h1.393c1.94 0 2.443-.516 3.358-2.766l.057-.121-6.306-13.742h4.379l3.97 9.155 3.707-9.155h4.279L107.7 20.409c-1.784 4.034-3.352 5.562-6.692 5.562zm-35.884 0V5.725h2.661l.688 1.353A7.1 7.1 0 0171.585 5.3a7.619 7.619 0 017.8 7.861 7.641 7.641 0 01-7.8 7.885 7.131 7.131 0 01-4.094-1.246v6.174zM67.2 13.166a4.054 4.054 0 108.108 0 4.054 4.054 0 10-8.108 0zm13.259-.022A7.625 7.625 0 0188.265 5.3a7.256 7.256 0 014.889 1.82l.431-1.42h3v14.885h-3.151l-.346-1.332a7.236 7.236 0 01-4.823 1.775 7.652 7.652 0 01-7.807-7.884zm4.078 0a4.054 4.054 0 108.108 0 4.054 4.054 0 10-8.108 0zm-60.818 1.18v-8.6h4.024v8.141c0 2.117 1.12 3.38 2.979 3.38s2.957-1.29 2.957-3.38v-8.14H37.7v8.6c0 4.019-2.771 6.7-6.98 6.7s-7.001-2.682-7.001-6.701zm33.8 6.283V5.725h4.024v14.882zm-4.778 0c-3.274 0-5.286-2.012-5.286-5.314V8.96H44.76v-.87l5.878-6.249h.769v3.884h4.107V8.96h-4.039v5.8a2.071 2.071 0 002.292 2.264H55.6v3.583zm-13.3 0V.361h4.019v20.246zm-21.286 0v-8.668c0-1.987-.78-3.034-2.237-3.034-1.8 0-2.862 1.323-2.862 3.653v8.05H9.128v-8.669c0-1.987-.757-3.034-2.2-3.034-1.82 0-2.907 1.323-2.907 3.653v8.05H0V5.725h2.812l.753 1.845A5.723 5.723 0 018 5.372a4.824 4.824 0 014.321 2.382 5.628 5.628 0 014.607-2.382c3.078 0 5.241 2.415 5.241 5.9v9.333zM57.522 3.741V0h4.009v3.741z"
          transform="translate(-1010.132 -157.022) translate(1059.481 165.631)"
        />
      </g>
    </svg>
  );
}

export function SolidIcon() {
  return (
    <svg
      width="87"
      height="87"
      viewBox="0 0 87 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M70.0201 60.047C68.7583 62.0651 67.2707 63.9328 65.5861 65.614C62.7004 68.5056 59.2724 70.7993 55.4985 72.3634C51.7247 73.9275 47.6792 74.7314 43.5941 74.729C39.5087 74.7315 35.4631 73.9277 31.6891 72.3635C27.915 70.7994 24.4869 68.5057 21.6011 65.614C19.9166 63.9334 18.4299 62.0656 17.1701 60.047L6.45605 60.047C7.18792 61.6949 8.03016 63.2915 8.97705 64.826C10.65 67.5461 12.637 70.06 14.8971 72.316C18.6621 76.091 23.1355 79.0855 28.0606 81.1276C32.9856 83.1697 38.2654 84.2192 43.5971 84.216C48.9287 84.2192 54.2085 83.1697 59.1336 81.1276C64.0586 79.0855 68.532 76.091 72.2971 72.316C74.5571 70.06 76.5441 67.5461 78.2171 64.826C79.1618 63.2913 80.0021 61.6947 80.7321 60.047H70.0201Z"
        fill="white"
      />
      <path
        d="M73.945 50.563C75.1213 45.425 74.9739 40.0726 73.5166 35.0072C72.0593 29.9418 69.3398 25.3293 65.613 21.602L50.298 36.914L43.598 43.614L36.898 36.914L21.573 21.602C17.8459 25.3291 15.1262 29.9416 13.6687 35.007C12.2112 40.0724 12.0637 45.425 13.24 50.563H3.57297C2.19213 42.5472 3.24374 34.3016 6.59223 26.889C9.94072 19.4764 15.4326 13.2366 22.36 8.97396L29.315 15.929L43.594 30.209L57.873 15.93L64.827 8.97396C67.5455 10.6503 70.0591 12.6381 72.317 14.897C76.9214 19.5006 80.3515 25.1438 82.3182 31.3508C84.2848 37.5579 84.7302 44.1467 83.617 50.562L73.945 50.563ZM43.594 12.458C41.903 12.4574 40.2149 12.5938 38.546 12.866L30.74 5.05996C39.0843 2.27852 48.1057 2.27852 56.45 5.05996L48.641 12.866C46.9724 12.5938 45.2846 12.4574 43.594 12.458Z"
        fill="white"
      />
    </svg>
  );
}

export function ColoredIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="87"
      height="87"
      viewBox="0 0 87 87"
    >
      <defs>
        <linearGradient
          id="a"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#ed7015" />
          <stop offset="1" stopColor="#eda215" />
        </linearGradient>
        <linearGradient
          id="b"
          x1="0.799"
          x2="0"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#295fa6" />
          <stop offset="1" stopColor="#2197c6" />
        </linearGradient>
        <clipPath id="d">
          <rect width="87" height="87" />
        </clipPath>
      </defs>
      <g id="c" clipPath="url(#d)">
        <g transform="translate(2.973 2.974)">
          <path
            d="M63.564,0A31.325,31.325,0,0,1,59.13,5.567a31.043,31.043,0,0,1-21.992,9.115A31.044,31.044,0,0,1,15.145,5.567,31.2,31.2,0,0,1,10.714,0H0A40.074,40.074,0,0,0,2.521,4.779a40.735,40.735,0,0,0,5.92,7.49,40.5,40.5,0,0,0,28.7,11.9,40.5,40.5,0,0,0,28.7-11.9,40.74,40.74,0,0,0,5.92-7.49A40.094,40.094,0,0,0,74.276,0Z"
            transform="translate(3.483 57.073)"
            fill="url(#a)"
          />
          <path
            d="M70.972,47.589A31.133,31.133,0,0,0,62.64,18.628L47.325,33.94l-6.7,6.7-6.7-6.7L18.6,18.628a31.132,31.132,0,0,0-8.333,28.961H.6A40.716,40.716,0,0,1,19.387,6l6.955,6.955L40.621,27.235,54.9,12.956,61.854,6a41.067,41.067,0,0,1,7.49,5.923,40.614,40.614,0,0,1,11.3,35.665ZM40.621,9.484a31.3,31.3,0,0,0-5.048.408L27.767,2.086a40.651,40.651,0,0,1,25.71,0L45.668,9.892A31.292,31.292,0,0,0,40.621,9.484Z"
            transform="translate(0 0)"
            fill="url(#b)"
          />
        </g>
      </g>
    </svg>
  );
}
